import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconBandsintownStyle0 = gravityIconIndividualCss;

const GravityIconBandsintown = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '2a71afa9ae4dcdeff8c36056edf533d7802f82c5', color: this.color, size: this.size }, h("svg", { key: '9d2759c03fbe4f9462c8a05daf838923a3ea5679', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '8fc8c5d41ed9d8d9e4b0244bf8748ab7db8af1e6', d: "M4 17.88V4h2.69v11.346h7.632v-.743H7.458v-2.536h9.553v5.813H4Z", fill: "currentColor" }), h("path", { key: '748f59e006a2ae9d4424cded4524b9ddafc1c018', d: "M14.322 4h2.664v7.12h-2.664V4Zm-3.561 3.74h2.664v3.381h-2.664V7.739Zm-.715 0H7.382v3.381h2.664V7.739Z", fill: "currentColor" }))));
    }
};
GravityIconBandsintown.style = GravityIconBandsintownStyle0;

export { GravityIconBandsintown as gravity_icon_bandsintown };

//# sourceMappingURL=gravity-icon-bandsintown.entry.js.map